import { Formik } from 'formik';
import dayjs from 'dayjs';
import CustomModal from '../../../components/CustomModal';
import { Button, DatePicker, Dropdown, InputField, Text } from '../../../components/SecondaryMarket';
import ViewReverse from '../../../components/ViewReverse';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import { manager_add_validation_schema } from '../../../validations_schemas/general_information_validation_schema';
import { alphabet_regix } from '../../../utils/functions';

const ManagerEditModal = ({
  isOpen,
  onClose,
  getContentKey,
  getEditManagerInitialValues,
  handleEditManagerSubmit,
  corporate_dropdown_data,
  corporate_loading,
  isManagerListFetchByWathq,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <CustomModal isOpen={isOpen} onClose={onClose} maxWidth={'lg'} heading={getContentKey('edit_manager')}>
      {isOpen && (
        <Formik
          enableReinitialize
          initialValues={getEditManagerInitialValues()}
          validationSchema={manager_add_validation_schema}
          onSubmit={handleEditManagerSubmit}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
        >
          {({ values: managerValues, errors: managerErrors, setFieldValue: setManagerFieldValue, handleSubmit, resetForm: resetManagerForm }) => (
            <div className='bg-light-background p-6 rounded-lg mt-4'>
              <div className='space-y-6'>
                <ViewReverse className={'gap-6 mt-2'} isResponsive>
                  <InputField
                    label={getContentKey('name_heading')}
                    isRequired
                    placeholder={getContentKey('name_heading')}
                    className={'bg-white'}
                    value={managerValues?.name}
                    maxLength={50}
                    isDisabled={isManagerListFetchByWathq && managerValues?.isNameFetchByWathq}
                    onChange={(text) => {
                      if (alphabet_regix.test(text)) {
                        setManagerFieldValue('name', text);
                      }
                    }}
                    error={getContentKey(managerErrors?.name)}
                  />
                  <InputField
                    label={getContentKey('identification_id_label')}
                    isRequired
                    placeholder={getContentKey('identification_id_label')}
                    className={'bg-white'}
                    value={managerValues?.identificationId}
                    maxLength={20}
                    isDisabled={isManagerListFetchByWathq && managerValues?.isIdentificationIdFetchByWathq}
                    onChange={(text) => {
                      setManagerFieldValue('identificationId', text);
                    }}
                    error={getContentKey(managerErrors?.identificationId)}
                  />
                  <InputField
                    label={getContentKey('indentification_type_label')}
                    isRequired
                    placeholder={getContentKey('indentification_type_label')}
                    className={'bg-white'}
                    value={managerValues?.identificationType}
                    maxLength={50}
                    isDisabled={isManagerListFetchByWathq && managerValues?.isIdentificationTypeFetchByWathq}
                    onChange={(text) => {
                      setManagerFieldValue('identificationType', text);
                    }}
                    error={getContentKey(managerErrors?.identificationType)}
                  />
                </ViewReverse>

                <ViewReverse className={'gap-6 mt-8'} isResponsive>
                  <Dropdown
                    label={getContentKey('country_label')}
                    placeholder={getContentKey('country_label')}
                    valueKey={'name'}
                    value={managerValues?.nationalityId ? corporate_dropdown_data?.country?.find((item) => item?.id === managerValues?.nationalityId) : null}
                    isRequired={false}
                    options={corporate_dropdown_data?.country ?? []}
                    isDisabled={isManagerListFetchByWathq && managerValues?.isNationalityIdFetchByWathq}
                    onSelect={(val) => {
                      setManagerFieldValue('nationalityId', val?.id);
                    }}
                    error={getContentKey(managerErrors?.nationalityId)}
                  />
                  <DatePicker
                    label={getContentKey('date_of_birth')}
                    className={'bg-white'}
                    isRequired
                    isLabelHeight
                    labelDivClass={'md:h-6'}
                    maxDate={dayjs()}
                    placeholder={getContentKey('date_birth_label')}
                    selectedDate={managerValues?.birthDate}
                    isDisabled={isManagerListFetchByWathq && managerValues?.isBirthDateFetchByWathq}
                    onChange={(date) => {
                      setManagerFieldValue('birthDate', date ? dayjs(date).format('YYYY/MM/DD') : '');
                    }}
                    error={getContentKey(managerErrors?.birthDate)}
                  />
                  <div className='w-full hidden md:flex' />
                </ViewReverse>
              </div>

              <ViewReverse className={'w-full mt-5 justify-end gap-2'} isResponsive>
                <Button
                  text={getContentKey('cancel')}
                  className={'w-full md:w-44 bg-white border border-grey text-black'}
                  weight={TextWeight.bold}
                  textSize={fontSizes.h14}
                  onClick={() => (resetManagerForm({ values: getEditManagerInitialValues() }), onClose())}
                />
                <Button
                  text={getContentKey('edit')}
                  className={'w-full md:w-44 bg-light-blue border-none'}
                  weight={TextWeight.bold}
                  textSize={fontSizes.h14}
                  onClick={handleSubmit}
                  loading={corporate_loading}
                  isDisabled={corporate_loading}
                />
              </ViewReverse>
            </div>
          )}
        </Formik>
      )}
    </CustomModal>
  );
};

export default ManagerEditModal;
